import * as Optional from "optional-js";

import i18n from 'l10n';

import GenericView from 'js/views/generic.view';
import UserModel from 'js/models/userrelatedinfo.model';
import SubscriberModel from 'js/models/subscriber.model';
import Template from 'js/templates/subscribers.listgroup.hbs';
import MyModel from 'js/models/subscriber.groups.model';
import {_} from "backboneAdapter";
import {debounce, domain, el, memoize, tagName, template} from "../adapters/backbone-decorators";
import {parser as tellody} from "tellody";

require('callingcodewithdefaultcountry');
require('metroHelpers');

@el("#contacts-container")
@tagName('span')
@domain('.page')
@template(Template)
class SubscribersBaseView extends GenericView {
    listview = '#listview';
    letterTabs = '#letter-tabs';
    searchResults = '#searchResults';
    searchResultsSize = '#search-results-size';
    countBlockedSelector = '#count-blocked';
    countEmailBouncedSelector = '#count-email-bounced';
    countSmsBouncedSelector = '#count-sms-bounced';
    listviewViewport = '#listview-viewport';

    load(options) {
        this.groupId = options.groupId;
        this.userModel = new UserModel();
        this.model = new MyModel();
        this.model.set("postpaid", options.postpaid);
        this.isCalledFromSelectionView = options.isCalledFromSelectionView;
        Optional
            .ofNullable(options)
            .map(({isCalledFromSelectionView}) => isCalledFromSelectionView)
            .ifPresentOrElse(_.noop, () => this.renderCollection());
    }

    renderCollection() {
        this.renderView();
    }

    renderView(dontRender) {
        var self = this;
        this.singleLetterTabWidth = 16;
        this.doubleLetterTabWidth = 31;
        if (!dontRender) {
            super.render();
        }
        if (this.groupModel && this.groupModel.get("groupType") === "query") {
            this.$('#nocontactsingroupsearch').text(i18n.t('groups.noContactsToQueryGroupsearch'));
        }
        this.$(".subscribers-rolodex").find(".group-title").off("click").on("click", ev => {
            ev.preventDefault();
            ev.stopPropagation();
            return false;
        });
        this.lastScrollTop = 0;
        this.$el.find(this.listviewViewport).on('scroll', evt => {

            //------ USED ONLY on Config page -- BEGIN
            const $configContactsLoadingSpinner = $("#contacts-container .contact-container-spinner");

            const currentScrollFromTop = $(evt.currentTarget).scrollTop();
            var scrollFromTopToBottom = currentScrollFromTop > this.lastScrollTop;

            //move the spinner either on top, or on bottom, according to scroll direction
            if(scrollFromTopToBottom) // downscroll code
                $configContactsLoadingSpinner.css("top", "90%");
            else // upscroll code
                $configContactsLoadingSpinner.css("top", "40%");

            this.lastScrollTop = currentScrollFromTop;
            //------ USED ONLY on Config page -- END


            this.redrawContacts(evt, this.filter, this.filterBounce);
        });

        // If element with id listview-viewport exists, redraw contacts with current filter
        if (this.$el.find('#listview-viewport').length) {
            this.redrawContacts(null, this.filter);
        }

        this.countBlocked();
        // self.countBounced();
    }

    contactTop(i, self) {
        var group = this.groups[parseInt(i)];
        return group[1] * self.rowHeight;
    }

    showNoContactsToSearchMessage() {
        if (this.inGroupContactsSearch) {
            this.$("#nocontactsingroupsearch").show();
        } else if (this.inMsgConfigContactsSearch) {
            this.$("#nocontactsinmsgconfigsearch").show();
        } else {
            this.$("#nocontactssearch").show();
        }
    }

    hideNoContactsToSearchMessage() {
        this.$("#nocontactssearch").hide();
        this.$("#nocontactsingroupsearch").hide();
        this.$("#nocontactsinmsgconfigsearch").hide();
    }

    showContactsSearchBox() {
        if (this.inGroupContactsSearch) {
            this.$("#contactssearchicon").show();
        }
        if (this.inMsgConfigContactsSearch) {
            this.$("#contactsselect").show();
        }
        this.$("#contactsearch").show();
    }

    hideContactsSearchBox() {
        if (this.inGroupContactsSearch) {
            this.$("#contactssearchicon").hide();
        }
        if (this.inMsgConfigContactsSearch) {
            this.$("#contactsselect").hide();
        }
        this.$("#contactsearch").hide();
    }

    drawTabs() {
        this.$el.find('#letter-tabs').empty();
        var width = this.$el.find(this.listview).width();
        if (!width) {
            return;
        }
        var groupNumber = this.groups.length;
        var lowerFillFactor = 1;
        var upperFillFactor = lowerFillFactor + 1;
        var lowerFillFactorTabNumber = groupNumber;
        var upperFillFactorTabNumber = 0;
        var lowerFillFactorTabWidth = this.singleLetterTabWidth;
        var upperFillFactorTabWidth = this.doubleLetterTabWidth;
        while (width < lowerFillFactorTabNumber * lowerFillFactorTabWidth + upperFillFactorTabNumber * upperFillFactorTabWidth) {
            if (lowerFillFactorTabNumber === 0) {
                lowerFillFactor++;
                upperFillFactor = lowerFillFactor + 1;
                lowerFillFactorTabNumber = Math.ceil((groupNumber - upperFillFactor) / lowerFillFactor);
                upperFillFactorTabNumber = 1;
                lowerFillFactorTabWidth = this.doubleLetterTabWidth;
            } else {
                upperFillFactorTabNumber++;
                lowerFillFactorTabNumber = Math.max(0, Math.ceil((groupNumber - upperFillFactorTabNumber * upperFillFactor) / lowerFillFactor));
            }
        }
        this.currentGroup = 0;
        while (lowerFillFactorTabNumber + upperFillFactorTabNumber > 0) {
            var group = this.groups[this.currentGroup];
            var tabText = group[0];
            var currentFillFactor = lowerFillFactorTabNumber > 0 ? lowerFillFactor : upperFillFactor;
            if (currentFillFactor > 1) {
                var lastGroupInTab = Math.min(this.currentGroup + currentFillFactor - 1, groupNumber - 1);
                tabText += '-' + this.groups[lastGroupInTab][0];
            }
            var el = $(`<span class="rolodex-tab" id="${this.currentGroup}">${tabText}</span>`);
            el.bind('click', event => {
                const y = this.contactTop(event.currentTarget.id, this);
                this.$el.find(this.listviewViewport).scrollTop(y);
            });
            this.$el.find('#letter-tabs').append(el);
            this.currentGroup += currentFillFactor;
            if (lowerFillFactorTabNumber === 0) {
                upperFillFactorTabNumber--;
            } else {
                lowerFillFactorTabNumber--;
            }
        }
    }

    redrawContacts(evt, filter, filterBounce) {
        if (this.$el.find(this.listviewViewport)) this.groupFunc(filter, filterBounce);
    }

    @memoize((filter, filterBounce) => `${filter || ''}-${filterBounce || ''}` )
    async getLetterTabsAndSubscriptionCounts(filter, filterBounce) {
        const url = '/CampaignCloud/Subscription/getLetterTabsAndSubscriptionCounts';
        const data = {};
        if (filter) {
            data['filter'] = filter;
        }
        if (this.groupId) {
            data['groupId'] = this.groupId;
        }
        if (this.isCalledFromSelectionView) {
            data['channel'] = this.campaignChannel;
        }
        if (this.campaignId) {
            data['channel'] = this.campaignChannel;
            data['campaignId'] = this.campaignId;
        }
        if (filterBounce) {
            data['filterBounce'] = filterBounce;
        }

        return await $.ajaxDefaultQ({
            url: url,
            type: 'post',
            data: data,
            dataType: 'json'
        });
    }

    async groupFunc(filter, filterBounce) {
        const $configContactsLoadingSpinner = $("#contacts-container .contact-container-spinner");
        const $contactsLoadingSpinner = $('#contactsLoadingSpinner');
        $contactsLoadingSpinner.show();

        try {
            const response = await this.getLetterTabsAndSubscriptionCounts(filter, filterBounce);
            this.groups = response.groups;
            this.subscribersCollection.length = response.length;
            this.drawTabs();
            this.rowHeight = 45;
            var totalHeight = this.subscribersCollection.length * this.rowHeight;
            this.$el.find(this.listview).css('height', totalHeight);
            if (filter || filterBounce) {
                this.$el.find(this.searchResultsSize).html(this.subscribersCollection.length);
                this.$el.find(this.searchResults).show();
            }
            const e = this.$el.find(this.listviewViewport);
            if (e.length > 0) {
                const scrollTop = e.scrollTop();
                const scrollTopElement = Math.floor(scrollTop / this.rowHeight);

                const heightOfVisibleContacts = this.rowHeight * 10;
                /* use the `heightOfVisibleContacts` height in order to be able to load contacts on Page load */
                const listViewHeight = location.href.indexOf('Contacts.htm') > -1 ? this.$el.find(this.listviewViewport).height() : heightOfVisibleContacts;
                const visibleElements = Math.ceil(listViewHeight / this.rowHeight);

                //used only on campaign config (both NOT_STARTED and SCHEDULED)
                // const $configContactsLoadingSpinner = $("#contacts-container .contact-container-spinner");
                $configContactsLoadingSpinner.show();
                this.renderOnDemand(scrollTopElement, visibleElements, filter, filterBounce);
            }
            this.$el.find('#totalContacts').html(`(${response.length})`);
            if (!response.length && !this.filter) {
                console.log("Im here boi")
                this.hideContactsSearchBox();
                this.showNoContactsToSearchMessage();
            } else {
                this.hideNoContactsToSearchMessage();
                this.showContactsSearchBox();
            }
        } catch (e) {
            console.log(e);
        }
        $contactsLoadingSpinner.hide();
        $configContactsLoadingSpinner.hide();
    }

    @memoize((s, v, f, fb) => `s${s}v${v}f${f}fb${fb}`)
    async fetchVisible(start, visibleElements, filter, filterBounce) {
        const url = '/CampaignCloud/Subscription/getWithFilters';
        var data = {
            from: start,
            per_page: visibleElements
        };
        if (filter) {
            data['filter'] = filter;
        }
        if (this.groupId) {
            data['groupId'] = this.groupId;
        }
        if (this.isCalledFromSelectionView) {
            data['channel'] = this.campaignChannel;
        }
        if (this.campaignId) {
            data['channel'] = this.campaignChannel;
            data['campaignId'] = this.campaignId;
        }
        if (filterBounce) {
            data['filterBounce'] = filterBounce;
        }

        return await $.ajaxDefaultQ({
            url: url,
            type: 'post',
            data: data,
            dataType: 'json'
        });
    }

    @debounce(300)
    async renderOnDemand(start, visibleElements, filter, filterBounce) {
        if (!visibleElements) return;
        const $contactsLoadingSpinner = $('#contactsLoadingSpinner');
        $contactsLoadingSpinner.show();

        //used on campaign config (both DRAFT and SCHEDULED campaigns) and on Contacts.htm
        const $configContactsLoadingSpinner = $("#contacts-container .contact-container-spinner");

        try {
            const {
                statuses,
                emailBounced,
                smsBounced,
                models,
                photos
            } = await this.fetchVisible(start, visibleElements, filter, filterBounce);
            const statusesObj = _.object(statuses);
            const emailBouncedObj = _.object(emailBounced);
            const smsBouncedObj = _.object(smsBounced);
            const newModels = [];
            this.$el.find(this.listview).empty();
            _.each(models, (model, index) => {
                const tempModel = new SubscriberModel(model);
                tempModel.top = (start + index) * this.rowHeight;
                var id = model.subscriptionId;
                tempModel.set('status', statusesObj[id]);
                tempModel.set('emailBounced', emailBouncedObj[id]);
                tempModel.set('smsBounced', smsBouncedObj[id]);
                tempModel.set("hasPhoto", _.object(photos)[id]);
                newModels.push(tempModel);
            });
            
            this.iterFunc(this, newModels);
        } catch (e) {
            console.log(e);
        }
        $contactsLoadingSpinner.hide();
        $configContactsLoadingSpinner.hide();
    }

    iterFunc(self, models) {
        for (var i = 0; i < models.length; i++) {
            var model = models[i];
            var theId = model.get("subscriptionId");
            var el = $(`<span class="subscriber-row ui-draggable" id="subscriber-${theId}" style="width:100%;position:absolute;top:${model.top}px;"></span>`);
            self.$el.find(this.listview).append(el);
            self.modelRendering(model, el);
        }
        this.trigger("rendered:contacts");
    }

    @debounce(800)
    dosearch(fromQb) {
        const $searchBox = this.$el.find('.searchbox');
        $searchBox.parent().removeClass("error-state")
        var text = $searchBox.val();
        const filledIn = text.length > 0;

        if (!filledIn) this.$el.find(this.searchResults).hide();
        if (text) {
            if (!text.startsWith("q:")) {
                text = text.toLowerCase();
            } else if (!fromQb === false) {
                this.$('.querybuilder').show();
                try {
                    const rules = this.parsedQueryToRules(tellody.parse(text.replace("q:", "")));
                    if (rules) {
                        this.$('#builder-plugins').queryBuilder(this.queryBuilderOptions);

                        this.$('#builder-plugins').queryBuilder('setRules', rules);
                    }
                } catch (e) {
                    console.warn("Given expression is not valid.");
                    $searchBox.parent().addClass("error-state")
                    return;
                }

            }
        }
        this.filter = filledIn && text;
        this.redrawContacts(null, this.filter);
        this.inContactsSearch = filledIn;
        this.$el.find(this.listviewViewport).scrollTop(0);
    }

    @debounce(800)
    doFilterBounce(selectedValue) {
        this.filterBounce = selectedValue;
        if (selectedValue == "") this.$el.find(this.searchResults).hide();
        
        if (selectedValue !== null) {
            this.redrawContacts(null, null, selectedValue);
        }
    }

    newSubscriberView(model) {
        return new this.SubscriberView({model: model});
    }

    countBlocked() {
        const data = {};

        if (this.groupId) {
            data['groupId'] = this.groupId;
        }

        const alertSideEffects = (selector, keyword, count) => {
            const $el = this.$(selector);

            if (count > 0)
                $el.addClass("text-alert");
            else
                $el.removeClass("text-alert");

            $el.text(i18n.t(keyword, {count: count}));
        };

        const fetchAndPrint = (url, selector, keyword) => {
            $.ajaxDefaultQ({
                url,
                type: 'post',
                data: data,
                dataType: 'json'
            }).done(_.partial(alertSideEffects, selector, keyword))
                .fail(console.log);
        };
        fetchAndPrint('/CampaignCloud/Subscription/getTotalBlocked', this.countBlockedSelector, "contacts.countBlocked");
        fetchAndPrint('/CampaignCloud/Subscription/getTotalEmailBounced', this.countEmailBouncedSelector, "contacts.countEmailBounced");
        fetchAndPrint('/CampaignCloud/Subscription/getTotalSmsBounced', this.countSmsBouncedSelector, "contacts.countSmsBounced");
    }
}

export default SubscribersBaseView;
